import React, { Component } from 'react';
import Sidebar from './SideBar'; 
import AddProduct from './AddProduct'; 
import Product from './Product'; 
import Requests from './Requests'; 
import Profile from '../pages/Profile';
import Accueil from '../pages/Accueil';
import NavBar2 from '../components/Navbar2/NavBar2.js';

class DashUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeComponent: 'AddProduct',
      isSidebarVisible: true,
    };
  }

  setActiveComponent = (component) => {
    this.setState({ activeComponent: component });
  };

  setIsSidebarVisible = (visible) => {
    this.setState({ isSidebarVisible: visible });
  };

  renderComponent() {
    const { activeComponent } = this.state;

    switch (activeComponent) {
      case 'AddProduct':
        return <AddProduct />;
      case 'Product':
        return <Product />;
      case 'Requests':
        return <Requests />;
      case 'Profile':
        return <Profile />;
      case 'Accueil':
        return <Accueil />;
      default:
        return <AddProduct />;
    }
  }

  render() {
    const { isSidebarVisible } = this.state;

    return (
      <div style={{overflow:'hidden'}}>
      <div style={{
          boxShadow: '1px 2px 9px 0 gray',
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 1000,

        }}>
         <NavBar2 /> 
        </div>
        {isSidebarVisible && (
          <Sidebar
            setActiveComponent={this.setActiveComponent} 
            setIsSidebarVisible={this.setIsSidebarVisible} 
          />
        )}

        <div style={{ marginLeft: '250px', padding: '20px', width: '100%'}}>
          {this.renderComponent()}
        </div>
      </div>
    );
  }
}

export default DashUser;
